/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Components_Token_Icon_Twenty_Four_Hour_LabelInputs */

const en_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const de_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const pt_br2_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const tr_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const zh_cn2_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const zh_hk2_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const ko_kr2_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const ru_ru2_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

const es_419_components_token_icon_twenty_four_hour_label = /** @type {(inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.period}`)
};

/**
* | output |
* | --- |
* | "{period}" |
*
* @param {Components_Token_Icon_Twenty_Four_Hour_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_twenty_four_hour_label = /** @type {((inputs: Components_Token_Icon_Twenty_Four_Hour_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_Twenty_Four_Hour_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "de") return de_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "tr") return tr_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_twenty_four_hour_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_twenty_four_hour_label(inputs)
	return es_419_components_token_icon_twenty_four_hour_label(inputs)
});